import { IsOptional, IsBoolean } from 'class-validator';

export class PostCashTransactionGroupLinkResultDto {
  @IsOptional()
  @IsBoolean()
  success?: boolean;
}
